import { HouseholdMemberScreen } from "@/interactors/HouseholdMemberScreen";

export default function HouseholdMember() {
  return <HouseholdMemberScreen />;
}
